(() => {
  "use strict";
  const RT =
    window.BienestarRuntime ||
    (window.BienestarRuntime = (() => {
      const defs = new Map();
      const roots = (target, selector) => {
        const found = [];
        if (target?.nodeType !== 1 && target !== document) return found;
        if (target !== document && target.matches?.(selector))
          found.push(target);
        target.querySelectorAll?.(selector).forEach((node) => found.push(node));
        return found;
      };
      const mount = (def, root) => {
        if (def.instances.has(root)) return;
        const cleanups = [];
        const onCleanup = (fn) => {
          if (typeof fn === "function") cleanups.push(fn);
        };
        try {
          onCleanup(def.setup(root, onCleanup));
        } catch (error) {
          console.error("[Bienestar]", def.name, error);
        }
        def.instances.set(root, () => {
          for (let i = cleanups.length - 1; i >= 0; i--)
            try {
              cleanups[i]();
            } catch {}
          def.instances.delete(root);
          def.mounted.delete(root);
        });
        def.mounted.add(root);
      };
      const unmount = (def, target) => {
        for (const root of [...def.mounted])
          if (root === target || target.contains?.(root))
            def.instances.get(root)?.();
      };
      const load = (event) =>
        defs.forEach((def) =>
          roots(event.target, def.selector).forEach((root) => mount(def, root)),
        );
      const unload = (event) =>
        defs.forEach((def) => unmount(def, event.target));
      addEventListener("shopify:section:load", load);
      addEventListener("shopify:section:unload", unload);
      return {
        define(name, selector, setup) {
          const previous = defs.get(name);
          if (previous)
            for (const root of [...previous.mounted])
              previous.instances.get(root)?.();
          const def = {
            name,
            selector,
            setup,
            instances: new WeakMap(),
            mounted: new Set(),
          };
          defs.set(name, def);
          roots(document, selector).forEach((root) => mount(def, root));
          return def;
        },
        snapshot() {
          return Object.fromEntries(
            [...defs].map(([name, def]) => [name, def.mounted.size]),
          );
        },
      };
    })());
  RT.define("continuidad", '[data-bienestar-section="continuidad"]', (root) => {
    const scrollCta = root.querySelector("[data-continuity-scroll]");
    const onScroll = (event) => {
      const target = document.querySelector(scrollCta?.getAttribute("href"));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({
        behavior: matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "auto"
          : "smooth",
        block: "start",
      });
    };
    scrollCta?.addEventListener("click", onScroll);
    if (
      matchMedia("(prefers-reduced-motion: reduce)").matches ||
      !("IntersectionObserver" in window)
    )
      return () => scrollCta?.removeEventListener("click", onScroll);
    const section = root.querySelector(".continuity-story");
    section?.classList.add("is-reveal-ready");
    const observer = new IntersectionObserver(
      (entries) =>
        entries
          .filter((e) => e.isIntersecting)
          .forEach((e) => {
            e.target.classList.add("is-visible");
            observer.unobserve(e.target);
          }),
      { threshold: 0.15 },
    );
    root
      .querySelectorAll(".continuity-story__item")
      .forEach((node) => observer.observe(node));
    return () => {
      observer.disconnect();
      scrollCta?.removeEventListener("click", onScroll);
    };
  });
})();
